import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { ChartTypes } from 'types/shared';
import { EntityTypes } from 'context/entityContext';

import { TopicFilterNames } from 'components/TopicFilters/shared';

interface IChartsTrendUrlArgs {
  chartFrequency?: string;
  chartIds?: number;
  countryIds?: string | string[];
  customerFilter?: TopicFilterNames[];
  entityIds: string[];
  entityType: EntityTypes;
  limit?: number;
  chartType?: ChartTypes;
  download?: boolean;
}

function getChartsTrendUrl(args: IChartsTrendUrlArgs): string {
  const {
    chartFrequency,
    chartIds,
    countryIds,
    customerFilter,
    entityIds,
    entityType,
    limit,
    chartType,
    download,
  } = args;

  const type = entityTypeToApiType(entityType);

  const params = stringify({
    chartFrequency,
    chartIds,
    countryIds,
    customerFilter,
    limit,
    chartType,
    download,
  });

  return `/api/charts/trend/${type}/${entityIds}?${params}`;
}

export default getChartsTrendUrl;
